module.exports = __webpack_public_path__ + "img/Recurso 11@300x.5e5fb104.webp";